import { Autocomplete, Box, FormLabel, Paper, TextField, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next';

export default function FindDropdown({filterKeys, options, handleChange,filters }) {
    const { t } = useTranslation();
  return (
    <> 
    <Paper elevation={2} sx={{ p: 1, borderRadius: 2, border: '1px solid #ddd', backgroundColor: '#fefefe' }}>
    <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600 }}>
      {t("tab3.contents.filterOpt")}
    </Typography>
          {filterKeys?.map(({ key, label, required , disabled}) => (
            <Box key={key} >
             <FormLabel
                             htmlFor={label}
                             sx={{
                               color:  "text.primary",
                               
                             }}
                           >
                             {label}
                             {  required &&<span className={"required-asterisk"}> <i>(Required *)</i></span>}
                           </FormLabel>
              <Autocomplete
                size="small"
                disablePortal
                disabled={disabled}
                options={(options[key] || []).map(opt => opt.label || opt)}
                value={filters[key] || ''}
                onChange={handleChange(key)}
                renderInput={(params) => (
                  <TextField {...params}  variant="outlined" size="small"  PopperProps={{
                
                    placement: "bottom-start",
                modifiers: [
                  {
                    name: "flip",
                    enabled: false,
                  },
                  {
                    name: "preventOverflow",
                    enabled: true,
                    options: {
                      altAxis: true,
                      tether: false,
                      boundary: "veiwport",
                    },
                  },
                ],
              }}  />
                )}
              />
            </Box>
          ))}
          </Paper></>
  )
}
